import React, { useState, useEffect } from 'react';
import styles from './Header.module.css';
import { useAuth } from '../../utils/useAuthContext';
import LogoutIcon from '@mui/icons-material/Logout';
import PersonIcon from '@mui/icons-material/Person';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import FazendaSelector from './FazendaSelector';

const Header = () => {
  const { user } = useAuth();
  const [showDropdown, setShowDropdown] = useState(false);
  const [nomeUsuario, setNomeUsuario] = useState("Usuário");
  const [/* cargoUsuario */, setCargoUsuario] = useState("");
  const [modulo, setModulo] = useState("");

  useEffect(() => {
    const nomeStorage = localStorage.getItem("nome");
    const roleStorage = localStorage.getItem("role");
    const moduloStorage = localStorage.getItem("modulo");

    if (nomeStorage) setNomeUsuario(nomeStorage);
    else if (user?.nome) setNomeUsuario(user.nome);

    if (roleStorage) setCargoUsuario(roleStorage);
    if (moduloStorage) setModulo(moduloStorage);
  }, [user]);

  const primeiroNome = nomeUsuario.split(' ')[0];

  const handleLogout = () => {
    localStorage.removeItem("inteagro_token");
    localStorage.removeItem("nome");
    localStorage.removeItem("role");
    localStorage.removeItem("modulo");
    localStorage.removeItem("token");
    localStorage.removeItem("uid_unidade_producao");
    window.location.href = "/";
  };

  return (
    <header className={styles.containerMenu}>
      <nav className={styles.menu}>

        {/* Seletor de fazenda — só aparece no módulo agro */}
        {modulo === 'agro' && (
          <div style={{ flex: 1, display: 'flex', alignItems: 'center', paddingLeft: 16 }}>
            <FazendaSelector />
          </div>
        )}

        <div className={styles.menuUser}>
          <div className={styles.menuAvatar} onClick={() => setShowDropdown(!showDropdown)}>
            <AccountCircleIcon sx={{ fontSize: 30 }} />

            {showDropdown && (
              <div className={styles.suspense}>
                <div className={styles.headerGreeting}>
                  Olá, {primeiroNome}
                </div>
                <button className={styles.dropItem}><PersonIcon /> Meus Dados</button>
                <button className={styles.dropItem} onClick={handleLogout}><LogoutIcon /> Sair</button>
              </div>
            )}
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header;
